import { useCallback, useRef } from 'react';

import { useOutsideClick } from '@netfront/common-library';
import cx from 'classnames';

import { MenuDropDownProps } from './MenuDropdown.interfaces';

const MenuDropdown = ({ children, className = '', onOpenChange }: MenuDropDownProps) => {
  const menuRef = useRef(null);

  useOutsideClick(
    menuRef,
    useCallback(() => {
      if (onOpenChange) {
        onOpenChange(false);
      }
    }, [onOpenChange]),
  );

  return (
    <div
      ref={menuRef}
      className={cx('absolute', 'bg-white', 'shadow-lg', 'w-full', {
        [className]: className,
      })}
    >
      {children}
    </div>
  );
};

export { MenuDropdown };
